// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/InstagramAccounts_ConnectResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /instagram/accounts/connect
 *
 * Returns identifiers from the upstream instagram-messaging-service's
 * createOrUpdateAccount call: the local instagram_account_id, the
 * Instagram user identifiers, the long-lived token expiry, and the
 * device token used by the messaging client.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface InstagramAccounts_ConnectResponseDados {
instagram_account_id: number
ig_user_id: string
ig_username: string
token_expires_at?: string
device_token?: string
}

export type InstagramAccounts_ConnectResponse = ApiResponse<InstagramAccounts_ConnectResponseDados>;

registerResponseContract('InstagramAccounts_ConnectResponse', {
  instagram_account_id: { type: 'number',  required: true },
  ig_user_id:           { type: 'string',  required: true },
  ig_username:          { type: 'string',  required: true },
  token_expires_at:     { type: 'string',  required: false },
  device_token:         { type: 'string',  required: false },
})
